import "../../index86.css";
import { jsx as i, jsxs as h } from "react/jsx-runtime";
import { Fragment as g } from "react";
import { i as D } from "../../type-BFTbooL7.js";
import b from "../InfoPopup/index.js";
import _ from "../../hooks/useTranslation.js";
import { resolveToString as I } from "../../utils/translation.js";
const v = "common", N = {
  reducedListDisplayMoreLabel: "... and {n} more"
}, j = {
  namespace: v,
  strings: N
}, w = "_reduced-list-display_1czue_1", x = "_reduced-list-label_1czue_5", p = {
  reducedListDisplay: w,
  reducedListLabel: x
};
function L(a, e, d, n, o) {
  return a.reduce(
    (t, s, r, c) => {
      const l = e(s, r), u = /* @__PURE__ */ i(
        d,
        {
          ...n(s, r)
        },
        l
      );
      return t.push(u), r !== c.length - 1 && t.push(
        /* @__PURE__ */ i(
          g,
          {
            children: o
          },
          `separator-${l}`
        )
      ), t;
    },
    []
  );
}
function F(a) {
  const {
    list: e,
    title: d,
    renderer: n,
    rendererParams: o,
    keySelector: t,
    separator: s = ", ",
    maxItems: r = 4,
    minItems: c = 2
  } = a, l = _(j);
  if (D(e) || e.length === 0)
    return null;
  const m = L(e, t, n, o, s);
  if (e.length <= r)
    return /* @__PURE__ */ i("div", { className: p.reducedListDisplay, children: m });
  const u = e.slice(0, c), f = I(
    l.reducedListDisplayMoreLabel,
    { n: e.length - c }
  ), y = L(u, t, n, o, s);
  return /* @__PURE__ */ h("div", { className: p.reducedListDisplay, children: [
    y,
    /* @__PURE__ */ i(
      b,
      {
        className: p.reducedListLabel,
        infoLabel: f,
        withoutIcon: !0,
        title: d,
        description: /* @__PURE__ */ i("div", { children: m })
      }
    )
  ] });
}
export {
  F as default
};
